import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownList,
  Input
} from '@cokitchen/cokitchen-components';
import React, { Fragment, useState } from 'react';
import './styles.scss';
import { ArrowDownIcon } from 'cokitchen-icons';
import RemoveVendorModal from 'components/modals/remove-vendor-modal';
import { formatCurrency } from 'utils/functions';

const InventoryStoreItemEdit = () => {
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const vendorsArray = [
    {
      name: 'Vendor 1',
      price: '1000'
    },
    {
      name: 'Femite food ltd',
      price: '1000'
    }
  ];

  return (
    <Fragment>
      <div className='ml-2 md:ml-8 request'>
        <h4 className='text-[24px] font-semibold text-[#2E3031] mb-10'>Edit cab rice and spices</h4>
        <div className='bg-[#F7F7F8] w-full max-w-[678px] h-auto p-1 flex  justify-center items-center'>
          <div className='bg-white w-full maxw-[670px] h-auto rounded-md pt-6'>
            <div className='px-4 sm:px-7 pb-6'>
              <h4 className='font-semibold text-[20px]'>Update carb rice and spices</h4>
              <p className='text-xs text-gray-9'>Change item details</p>
              <div className='mt-4 w-full edit_form'>
                <Input
                  type='text'
                  label='Item name'
                  name='name'
                  className='w-full font-semibold'
                  placeholder='Carb rice and spices'
                  inputClass='!border-b-[2px] text-[#96999C] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px] text-sm'
                />
                <div className='mt-5 flex justify-between'>
                  <div className='w-full md:w-[340px] relative'>
                    <Input
                      type='text'
                      label='Min. qty'
                      name='name'
                      className='w-full text-sm'
                      placeholder='Carb rice and spices'
                      inputClass='!border-b-[2px] text-[#96999C] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px] text-s !pl-4'
                    />
                    <p className='text-sm text-[#96999C] absolute top-[55%] right-4 z-50'>gram</p>
                  </div>
                  <div className='w-full md:w-[250px]'>
                    <p className='font-semibold mb-2'>Category</p>
                    <Dropdown
                      content={
                        <div className='h-[44px] py-3 px-[14px] w-full text-sm flex justify-between items-center cursor-pointer !border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5]'>
                          <span className='text-[#6F7376] truncate'>Spices</span>
                          <ArrowDownIcon className='w-5 h-5 text-[#96999C]' />
                        </div>
                      }>
                      <DropdownList>
                        <DropdownItem>Spices</DropdownItem>
                        <DropdownItem>Spices</DropdownItem>
                      </DropdownList>
                    </Dropdown>
                  </div>
                </div>
                <div className='my-5 flex justify-between'>
                  <div className='w-full md:w-[340px] relative'>
                    <Input
                      type='text'
                      label='Unit (per g)'
                      name='name'
                      className='w-full'
                      placeholder='Carb rice and spices'
                      inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px] text-sm text-[#96999C]'
                    />
                  </div>
                  <div className='w-full md:w-[250px]'>
                    <Input
                      type='text'
                      label='Price (per g)'
                      name='name'
                      className='w-full'
                      placeholder='Carb rice and spices'
                      inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] text-sm text-[#96999C] !rounded-none h-[44px]'
                    />
                  </div>
                </div>
                {vendorsArray.map((vendor, index) => (
                  <div key={index} className='flex justify-between mb-5'>
                    <div className='w-full md:w-[340px] relative'>
                      <Input
                        type='text'
                        label='Vendor name'
                        name='name'
                        className='w-full'
                        value={vendor.name}
                        placeholder='Carb rice and spices'
                        inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none h-[44px] text-sm text-[#96999C]'
                      />

                      <div
                        className='absolute text-[#E60A2B] text-sm flex gap-1 items-center top-0 right-1 cursor-pointer'
                        onClick={() => setShowRemoveModal(true)}>
                        - <span>Remove</span>
                      </div>
                    </div>
                    <div className='w-full md:w-[250px] relative'>
                      <Input
                        type='text'
                        label='Price (per g)'
                        name='name'
                        className='w-full'
                        value={formatCurrency(vendor.price, { style: 'decimal' })}
                        placeholder='Carb rice and spices'
                        inputClass='!border-b-[2px] !border-b-[#D5D6D7] bg-[#F4F5F5] !rounded-none text-sm h-[44px] text-[#96999C]'
                      />
                      <p className='text-sm text-[#96999C] absolute top-[55%] right-4 z-50'>
                        &#8358;
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='flex justify-end gap-6 py-6 px-4 md:px-7 items-center border-t-2 border-t-[#F7F7F8]'>
              <p className='text-sm font-medium'>Cancel</p>

              <Button variant='block' color='primary' small className='w-[153px]'>
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
      <RemoveVendorModal
        isOpen={showRemoveModal}
        onRequestClose={() => setShowRemoveModal(false)}
      />
    </Fragment>
  );
};

export default InventoryStoreItemEdit;
